/**
 * AlmadarPostDigitalSovereigntyAlmadarProposalARPostPageView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait AlmadarPostDigitalSovereigntyAlmadarProposalARPostPage
 */

import { useAlmadarPostDigitalSovereigntyAlmadarProposalARPostPageLogic } from '@/hooks/traits/useAlmadarPostDigitalSovereigntyAlmadarProposalARPostPageLogic';
import type { AlmadarPostDigitalSovereigntyAlmadarProposalARPostPageConfig } from '@/hooks/traits/useAlmadarPostDigitalSovereigntyAlmadarProposalARPostPageLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { AlmadarPostDigitalSovereigntyAlmadarProposalARPostView as AlmadarPostDigitalSovereigntyAlmadarProposalARPostViewEntity } from '@app/shared';
import { AlmadarPostDigitalSovereigntyAlmadarProposalARPostHeaderView } from '@/components/traits/AlmadarPostDigitalSovereigntyAlmadarProposalARPostHeaderView';
import { AlmadarPostDigitalSovereigntyAlmadarProposalARPostFooterView } from '@/components/traits/AlmadarPostDigitalSovereigntyAlmadarProposalARPostFooterView';
import { AlmadarPostDigitalSovereigntyAlmadarProposalARPostView } from '@/components/traits/AlmadarPostDigitalSovereigntyAlmadarProposalARPostView';
import { Container } from '@almadar/ui/components';
import { Box } from '@almadar/ui/components';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface AlmadarPostDigitalSovereigntyAlmadarProposalARPostPageViewProps {
  config?: Partial<AlmadarPostDigitalSovereigntyAlmadarProposalARPostPageConfig>;
}

export function AlmadarPostDigitalSovereigntyAlmadarProposalARPostPageView({ config: propsConfig }: AlmadarPostDigitalSovereigntyAlmadarProposalARPostPageViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useAlmadarPostDigitalSovereigntyAlmadarProposalARPostPageLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['AlmadarPostDigitalSovereigntyAlmadarProposalARPostView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="AlmadarPostDigitalSovereigntyAlmadarProposalAR" trait="AlmadarPostDigitalSovereigntyAlmadarProposalARPostPage">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="AlmadarPostDigitalSovereigntyAlmadarProposalARPostPage">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><AlmadarPostDigitalSovereigntyAlmadarProposalARPostHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><Box bg="transparent" paddingY="xl" fullWidth={true}><Container maxWidth="xl" padding="lg" size="xl"><AlmadarPostDigitalSovereigntyAlmadarProposalARPostView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Container></Box><AlmadarPostDigitalSovereigntyAlmadarProposalARPostFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default AlmadarPostDigitalSovereigntyAlmadarProposalARPostPageView;
